import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Misc } from '../util/misc';
import { CalculoService } from 'src/app/services/calculo.service';
import { FaturamentoService } from 'src/app/services/faturamento.service';
import { PriceModelService } from 'src/app/services/price-resumo.service';
import { PriceResumoCampo } from 'src/app/models/price-resumo-campo.model';

@Component({
    selector: 'app-price-editar-valor',
    templateUrl: 'price-editar-valor.component.html',
})

export class PriceEditarValorComponent implements OnInit {

    basicForm: UntypedFormGroup;
    loading = false;

    constructor(
        private fb: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private calculoService: CalculoService,
        private faturamentoService: FaturamentoService,
        private toastr: ToastrComponent,
        private priceModelService: PriceModelService,
        public misc: Misc,
        private dialogRef: MatDialogRef<PriceEditarValorComponent>) {
        this.createForm();
    }

    ngOnInit() {
        this.basicForm.patchValue({
            receitaBrutaSugerido: this.data.receitaBrutaSugerido.toFixed(2)
        });
    }

    createForm() {
        this.basicForm = this.fb.group({
            receitaBrutaSugerido: [null, Validators.required]
        });
    }

    enterClick(event: KeyboardEvent) {
        event.preventDefault();

        if (event.keyCode === 13) {
            this.save();
        }
    }

    save() {
        this.loading = true;

        const receitaBrutaSugerido = parseFloat(this.basicForm.value.receitaBrutaSugerido);

        if (receitaBrutaSugerido <= 0) {
            this.toastr.mostrarMensagem('aviso', 'Atenção', 'Valor não poder ser igual ou menor que zero!');
            return;
        }

        this.calculoService.calcularProvisaoRiscoByReceitaBruta(this.data.estimativaId, receitaBrutaSugerido)
            .subscribe(paramProvisaoRisco => {
                if (paramProvisaoRisco) {
                    this.dialogRef.close(paramProvisaoRisco);
                }
            }, error => {
                this.misc.processError(error, 'Não foi possível atualizar a receita bruta adotada.');
            });
    }

    recalcularFaturamento(estimativaId: number) {
        this.faturamentoService.recalcularFaturamento(estimativaId).subscribe(faturamento => {
            this.dialogRef.close(faturamento);
        }, error => {
            this.misc.processError(error, 'Não foi possível recalcular o pricing.');
        }, () => {
            this.loading = false;
        });
    }

    close() {
        this.dialogRef.close();
    }
}
